import React from 'react';
import classnames from 'classnames';
import { fromPairs, map, get, isEqual, isEmpty, size } from 'lodash';

// local Dependencies
import { Form } from 'modules/form';
import { button as Button } from 'modules/button';
import { Icon } from 'modules/icon-bank';
import { getLabel } from 'utils/getLabel';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { drugIntakeSelection as DrugIntakeSelection } from 'modules/drugIntakeSelection';
 *
 * // render
 * <DrugIntakeSelection propName='propValue'/>
 */
export const drugIntakeSelection = ( props ) => {

    const className = classnames( 'ui-drug-intake-selection', props.className );
    const hasError = ! isEmpty( props.errorMessage );

    return (
        <div className={ className } onClick={ ( event ) => event.stopPropagation() }>
            <Form
                fields={ fromPairs( map( props.fields, ( field ) => [ field.name, field ] ) ) } // convert to object as specified by `Form` prop
                values={ props.values } // default values
                isValid={ false }
                mode='form'
                key={ size( props.value ) }
                onChangeCallBack={ props.onChangeCallBack }
                updatFieldsOnChange={ true }
                onSubmit={ ( { values, isValid } ) => {
                    if( isValid ) {
                        
                        props.onFormSubmit( {
                            rxNumber: values.rxNumber,
                            drugName: values.drugName,
                            isControlledMedication: values.isControlledMedication,
                            drugDirections: values.drugDirections,
                            requestType: values.requestType
                        } );
                    }
                } }
            >
                { ( { fields, values, isValid, errors, onChange, onSumbit } = {} ) => {

                    return (
                        <form

                            // onSubmit={ onSumbit }
                            className='ui-drug-intake-selection__form'
                        >
                            { /* fields */ }
                            { map( fields, ( field ) => {

                                if( get( field, 'config.hide' ) ) {
                                    return null;
                                }

                                const fieldClassName = classnames( 'ui-drug-intake-selection__form__field', `ui-drug-intake-selection__form__${field.name}` );

                                return (
                                    <field.view
                                        className={ fieldClassName }
                                        key={ field.name }
                                        name={ field.name }
                                        required={ field.required }
                                        placeholder={ field.placeholder }
                                        label={ field.title }
                                        onChange={ onChange }
                                        value={ values[ field.name ] }
                                        error={ errors[ field.name ] }
                                        options={ get( props.options, field.options ) }
                                        config={ field.config }
                                        subFields={ props.subFields }
                                        mask={ field.mask }
                                    />
                                );
                            } ) }
                            {/* button actions */}
                            <div className='ui-drug-intake-selection__form__actions'>
                                { map( props.actions, action => {
                                    return (
                                        <Button
                                            key={ action.name }
                                            id= { action.name }
                                            type= {  'button' }
                                            disabled={ 'cancel' !== action.name ? !isValid : false }
                                            { ...action }
                                            outline={ false }
                                            size='large'
                                            className='ui-drug-intake-selection__form__actions__action'
                                            onClick = { isEqual( 'cancel', action.name ) ?  () => {

                                                // popover.close();
                                                props.onCancelClick();
                                            } : () => onSumbit() }
                                        />
                                    );
                                } ) }
                            </div>
                        </form>
                    );
                } }
            </Form>

            {
                hasError && ! isEqual( props.mode, 'readonly' ) ? (
                    <div className='ui-drug-intake-selection__error'>
                        <div className='ui-drug-intake-selection__error__message'>
                            { getLabel( props.errorMessage ) }
                        </div>
                    </div>
                ) : null
            }

            { ! isEmpty( props.value ) && (
                <div className='ui-drug-intake-selection__selection'>

                    <div className='ui-drug-intake-selection__selection__header'>

                        { map( props.fields, field => {
                            return (
                                <div key={ field.name }  className='ui-drug-intake-selection__selection__header__section'>{ getLabel( field.title ) }</div>
                            );
                        } ) }

                    </div>

                    { map( props.value, ( val, index ) => {
                        return (
                            <div key={ index } className='ui-drug-intake-selection__selection__list'>
                                <div className='ui-drug-intake-selection__selection__list__section'>{ val.rxNumber }</div>
                                <div className='ui-drug-intake-selection__selection__list__section'>{ val.drugName }</div>
                                <div className='ui-drug-intake-selection__selection__list__section'>{ val.isControlledMedication }</div>
                                <div className='ui-drug-intake-selection__selection__list__section'>{ val.drugDirections }</div>
                                <div className='ui-drug-intake-selection__selection__list__section'>{ val.requestType }</div>
                                <div className='ui-drug-intake-selection__selection__list__action' onClick={ () => props.clearSelection( index ) }>
                                    <Icon id={ 'delete' } />
                                </div>
                            </div>
                        );
                    } ) }
                </div>
            ) }

        </div>
    );
};

// set display name
drugIntakeSelection.displayName = 'drugIntakeSelection';

// set default props
drugIntakeSelection.defaultProps = {};

// prop types
drugIntakeSelection.propTypes = {};
